const safeMethods = ['get', 'head', 'options']

export const canRetryRequest = config =>
  config.__allowAuthRetry || safeMethods.indexOf((config.method || 'get').toLowerCase()) >= 0

export const prepareAuthenticatedRequest = async (config, dependencies) => {
  dependencies.readAuthentication()

  if (dependencies.isUpload(config)) config.__skipAuthRetry = true

  if (dependencies.isTokenExpired() && dependencies.getRefreshToken()) {
    await dependencies.refresh()
    dependencies.readAuthentication()
  }

  const token = dependencies.getAccessToken()
  if (token) {
    config.headers = config.headers || {}
    config.headers.common = config.headers.common || {}
    config.headers.common.Authorization = 'Bearer ' + token
  } else if (config.headers && config.headers.common) {
    delete config.headers.common.Authorization
  }

  return config
}

export const handleUnauthorizedResponse = async (error, dependencies) => {
  const response = error.response
  const config = error.config || {}
  if (!response || response.status !== 401) throw error

  if (config.__skipAuthRetry) {
    await dependencies.failAuthentication()
    const uploadError = new Error(
      'Authentication expired after the upload started. The upload was not retried; confirm the file state before trying again.'
    )
    uploadError.code = 'UPLOAD_AUTH_EXPIRED'
    uploadError.originalError = error
    throw uploadError
  }

  if (!config.__authRetry && canRetryRequest(config) && dependencies.getRefreshToken()) {
    config.__authRetry = true
    try {
      await dependencies.refresh()
      const token = dependencies.getAccessToken()
      config.headers = config.headers || {}
      config.headers.Authorization = 'Bearer ' + token
      return dependencies.replay(config)
    } catch (refreshError) {
      await dependencies.failAuthentication()
      throw refreshError
    }
  }

  await dependencies.failAuthentication()
  throw error
}



// WEBPACK FOOTER //
// ./src/auth/requestAuthentication.js